<template>
  <div
    class="modal fade confirm-agreement-modal"
    :class="{ 'confirm-agreement-modal--eudora': brand === 'eudora' }"
    :id="modalId"
    tabindex="-1"
    role="dialog"
    aria-labelledby="confirmAgreementModalLabel"
    aria-hidden="true"
    :style="{ backgroundColor: backdropColor }"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="confirmAgreementModalLabel">Confirmar acordo</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-if="prepareToSetAgreement">
          <p class="option-label">Opção escolhida:</p>

          <div :class="selectedOptionClass + ' mt-3'" v-if="parseInt(prepareToSetAgreement.installmentNumber) <= 1">
            À vista por&nbsp;
            <span :class="priceClass">R${{ prepareToSetAgreement.installmentValueFormatted }}</span>
          </div>

          <div v-if="parseInt(prepareToSetAgreement.installmentNumber) > 1">
            <div :class="selectedOptionClass + ' mt-3 text-center'">
              <span v-if="prepareToSetAgreement.entryValue > 0">
                Entrada de R$ {{ prepareToSetAgreement.minimumEntryValueFormatted }}
                <br />+ {{ prepareToSetAgreement.installmentNumber }}x de
                <span :class="priceClass">R${{ prepareToSetAgreement.installmentValueFormatted }}</span>
              </span>
              <span v-else>
                {{ prepareToSetAgreement.installmentNumber }}x de
                <span :class="priceClass">R${{ prepareToSetAgreement.installmentValueFormatted }}</span>
              </span>
            </div>
          </div>

          <!-- Forma de pagamento -->
          <div class="payment-method-section mt-4 mb-3">
            <div class="text-center mb-2">
              <p class="mb-1 font-weight-bold" style="font-size: 1rem;">Forma de pagamento</p>
              <p class="mb-0 text-muted small">Selecione a forma de pagamento desejada</p>
            </div>
            <div class="payment-options-list mt-3">
              <div
                v-if="isAcceptCardEnabled && parseInt(prepareToSetAgreement.installmentNumber) <= 1"
                class="payment-option mb-2"
                :class="{ [paymentSelectedClass]: selectedPaymentMethod === 'L' }"
                @click="$emit('select-payment', 'L')"
              >
                <i class="fa fa-credit-card mr-2" aria-hidden="true"></i>
                <span>Cartão de crédito</span>
              </div>
              <div
                v-if="isPixPaymentEnabled && parseInt(prepareToSetAgreement.installmentNumber) <= 1"
                class="payment-option mb-2"
                :class="{ [paymentSelectedClass]: selectedPaymentMethod === 'P' }"
                @click="$emit('select-payment', 'P')"
              >
                <i class="fa fa-qrcode mr-2" aria-hidden="true"></i>
                <span>PIX</span>
              </div>
              <div
                class="payment-option mb-2"
                :class="{ [paymentSelectedClass]: selectedPaymentMethod === 'B' }"
                @click="$emit('select-payment', 'B')"
              >
                <i class="fa fa-barcode mr-2" aria-hidden="true"></i>
                <span>Boleto</span>
              </div>
            </div>
          </div>

          <div class="mt-3">
            <slot name="loading" />
          </div>

          <button
            class="btn btn-block text-white mt-4 btn-confirm"
            style="cursor: pointer; min-height: 40px"
            @click="$emit('confirm')"
            :disabled="!selectedPaymentMethod || loading"
            v-if="!loading"
          >
            CONFIRMAR ACORDO
          </button>
          <button
            class="btn btn-link btn-block"
            data-dismiss="modal"
            :style="{ cursor: 'pointer', color: cancelColor }"
            v-if="!loading"
          >
            CANCELAR
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isPixPaymentEnabled as readPixPaymentFlag } from '@/pages/home/utils/paymentFlags';

export default {
  name: 'ConfirmAgreementModal',
  props: {
    brand: { type: String, default: 'boticario' },
    prepareToSetAgreement: { type: Object, default: null },
    selectedPaymentMethod: { type: String, default: null },
    isAcceptCardEnabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  computed: {
    modalId() { return `confirmAgreementModal${this.brand === 'eudora' ? 'Eudora' : 'Boticario'}`; },
    backdropColor() { return 'rgba(0,0,0,0.5)'; },
    cancelColor() {
      return this.brand === 'eudora' ? '#613a53' : '#176e53';
    },
    selectedOptionClass() { return 'selected-option'; },
    priceClass() { return 'price'; },
    paymentSelectedClass() { return 'payment-option-selected'; },
    confirmBtnClass() { return 'btn-confirm'; },
    isPixPaymentEnabled() { return readPixPaymentFlag(); },
  },
};
</script>

<style scoped>
.payment-option {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
  background-color: #fff;
  transition: all 0.2s ease;
  font-family: 'Inter', sans-serif;
}
.payment-option:hover {
  border-color: #06a472;
  background-color: #f0f8f5;
}
.payment-option-selected {
  border-color: #06a472;
  background-color: rgba(6, 164, 114, 0.08);
  box-shadow: 0 0 0 2px rgba(6, 164, 114, 0.25);
}

.btn-confirm {
  background-color: #06a472 !important;
  border-color: #06a472 !important;
  border-radius: 8px !important;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
}
.btn-confirm:hover:not(:disabled) {
  background-color: #125c44 !important;
}

.confirm-agreement-modal--eudora .payment-option:hover {
  border-color: #613a53;
  background-color: rgba(97, 58, 83, 0.06);
}
.confirm-agreement-modal--eudora .payment-option-selected {
  border-color: #613a53;
  background-color: rgba(97, 58, 83, 0.1);
  box-shadow: 0 0 0 2px rgba(97, 58, 83, 0.25);
}
.confirm-agreement-modal--eudora .btn-confirm {
  background-color: #613a53 !important;
  border-color: #613a53 !important;
}
.confirm-agreement-modal--eudora .btn-confirm:hover:not(:disabled) {
  background-color: #4d2e42 !important;
}
.confirm-agreement-modal--eudora .price {
  color: #613a53 !important;
}
</style>
